import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-statistics",
  "use": "icon-statistics-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-statistics\"><g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-swindex=\"0\"><path d=\"M11 3.055A9.001 9.001 0 1 0 20.945 13H11z\" /><path d=\"M20.488 9H15V3.512A9.025 9.025 0 0 1 20.488 9\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol